module.exports = __webpack_public_path__ + "static/media/elevated3-desktop.372e9f20.webp";